import { ISchemaNull } from './null.types';
import { IsNever, SchemaTypeName } from './core';
import { ISchemaInput, ISIBare, NestedSchema, RootSchema } from '../union';

export * from './null.types';

/**  Types  */
type OptionalDescription<T extends ISchemaInput<ISchemaNull>> = Omit<T, 'description'> & {
    description?: string;
};

/**
 * Property value is null
 * - Note that a property with this value alone will not pass .toGraphQL() validation
 */
export function nullProperty(
    schema?: OptionalDescription<RootSchema<ISchemaInput<ISchemaNull, ISIBare<ISchemaNull>>>>
): RootSchema<ISchemaNull>;
export function nullProperty(
    schema?: OptionalDescription<NestedSchema<ISchemaInput<ISchemaNull, ISIBare<ISchemaNull>>>>
): NestedSchema<ISchemaNull>;
export function nullProperty(schema?: OptionalDescription<ISchemaInput<ISchemaNull>>): ISchemaNull {
    return {
        type: SchemaTypeName.null,
        default: null,
        description: ``,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = nullProperty({ description: '', $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = nullProperty({ description: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
